import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useLeisureActivities() {
    const [leisureActivities, setLeisureActivities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchLeisureActivities = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/leisure-activities`, { withCredentials: true });
            setLeisureActivities(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createLeisureActivity = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/leisure-activities`, payload, { withCredentials: true });
            await fetchLeisureActivities();
            return res.data?.leisure_activity;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchLeisureActivities]);

    const updateLeisureActivity = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/leisure-activities/${id}`, payload, { withCredentials: true });
            await fetchLeisureActivities();
            return res.data?.leisure_activity;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchLeisureActivities]);

    const deleteLeisureActivity = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/leisure-activities/${id}`, { withCredentials: true });
            await fetchLeisureActivities();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchLeisureActivities]);

    useEffect(() => {
        fetchLeisureActivities();
    }, [fetchLeisureActivities]);

    return {
        leisureActivities,
        loading,
        error,
        fetchLeisureActivities,
        createLeisureActivity,
        updateLeisureActivity,
        deleteLeisureActivity,
    };
}
